module.exports = __webpack_public_path__ + "img/2.e7860f5a.jpg";